import React, {Component} from 'react';
import { withRouter } from 'react-router-dom'
import store from "../../store";
import {REQUEST_FACILITIES_META_DATA} from "../../actions/facilitiesMetaActions";
import {REQUEST_FACILITIES_DATA} from "../../actions/facilitiesActions";
import connect from "react-redux/lib/connect/connect";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import FacilityAccordion from "../FacilityAccordion/FacilityAccordion";
import ReactToPrint from "react-to-print";
import {Checkbox, FormGroup, FormControlLabel} from "@material-ui/core";

const mapStateToProps = (state) => {
    return {
        rawFacilities: state.facilitiesData.rawFacilities,
        facilitiesMeta: state.facilitiesMetaData
    }
};

const mapDispatchToProps = dispatch => ({
    getFacilitiesMeta: () => dispatch({type: REQUEST_FACILITIES_META_DATA}),
    getRawFacilities: () => dispatch({type: REQUEST_FACILITIES_DATA})
});

class FacilitiesAll extends Component {

    constructor(props) {
        super(props);
        this.handleExpansionForPrint = this.handleExpansionForPrint.bind(this);
        this.state = {
            isAllOpen: false
        };
    }

    componentDidMount() {
        if (!Object.keys(this.props.facilitiesMeta).length > 0) {
            this.props.getFacilitiesMeta();
        }
        if (!this.props.rawFacilities) {
            this.props.getRawFacilities();
        }
    }

    handleExpansionForPrint = () => {
        this.setState((prevState) => ({
            isAllOpen: !prevState.isAllOpen
        }))
    }

    render() {

        const contacts = store.getState().facilitiesMetaData.contacts;
        const rawFacilities = store.getState().facilitiesData.rawFacilities;

        return (
                <div className="wrapper">
                    <Breadcrumbs pageTitle={"All Facilities"}/>
                    <div className="facilities-all-container">
                        <h1 className="two-three-rows__title facilities-all-heading">All Facilities</h1>
                        <FormGroup className="facilities-all-checkbox">
                            <FormControlLabel labelPlacement="top" control={<Checkbox onChange={this.handleExpansionForPrint} color="default" />} label="Expand Facilities" />
                        </FormGroup>
                        <ReactToPrint
                                content={() => this.accordion}
                                trigger={() => {return <button type="button" className="facilities-all-print-button" id="facilities-all-print-button" disabled={!this.state.isAllOpen}>Print All Facilities</button>}}
                        />
                    </div>
                    {
                        (contacts && rawFacilities) ?
                                <div className="mbl pbm ptm" ref={el => this.accordion = el}>
                                    <FacilityAccordion contacts={contacts} rawFacilities={rawFacilities} isAllOpen={this.state.isAllOpen} />
                                </div>
                                : null
                    }
                </div>
        )

    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FacilitiesAll));



// WEBPACK FOOTER //
// ./src/components/FacilitiesAll/FacilitiesAll.js